import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'

import { regions } from '../constants/regions'

export const useRegionStore = defineStore('region', () => {
  const currentRegionKey = useLocalStorage('region/current', 'cn')

  const currentRegion = computed(() => {
    return regions.find(region => region.envKey === currentRegionKey.value) || regions[0]
  })

  const setRegion = (regionKey: string) => {
    const region = regions.find(r => r.envKey === regionKey)
    if (region) {
      currentRegionKey.value = regionKey
    }
  }

  const getRegionByKey = (regionKey: string) => {
    return regions.find(region => region.envKey === regionKey)
  }

  return {
    currentRegion,
    currentRegionKey,
    regions,
    setRegion,
    getRegionByKey,
  }
})
